import Axios from "axios";
import ItemUpdateProfile from "../domain/ItemUpdateProfile";
import QueryOptions from "../sal-ui/QueryOptions";
import PagedResult from "./PagedResult";

class ItemUpdateProfileService {

    readonly basePath = "/item-update-profiles";

    public add(profile: ItemUpdateProfile): Promise<string> {
        return Axios.post(`${this.basePath}`, profile).then(value => value.data.id);
    }

    public update(id: string, profile: ItemUpdateProfile): Promise<void> {
        return Axios.put(`${this.basePath}/${id}`, profile);
    }

    public get(id: string): Promise<ItemUpdateProfile> {
        return Axios.get(`${this.basePath}/${id}`)
            .then(value => ItemUpdateProfile.fromPOJO(value.data));
    }

    public delete(profile: ItemUpdateProfile): Promise<void> {
        return Axios.delete(`${this.basePath}/${profile.id}`);
    }

    public getList(queryOptions: QueryOptions): Promise<PagedResult<ItemUpdateProfile>> {
        return Axios.get(`${this.basePath}?${queryOptions.toQueryParams()}`)
            .then(value => {
                const profiles = value.data.data.map((objectJson: object) => ItemUpdateProfile.fromPOJO(objectJson));

                return new PagedResult(value.data.total, profiles);
            });
    }
}

export default ItemUpdateProfileService;
